<template>
  <div>
    <template v-if="isDrill">
      <asc-label
        size="md"
        class="asc-report-single-value--text"
        :value="getText"
      ></asc-label>
      <span
        class="asc-report-single-value--value-drill"
        @click="handleDrillClick"
      >
        <asc-label size="md" :value="getValue"></asc-label>
      </span>

      <asc-label
        size="md"
        class="asc-report-single-value--note"
        :value="getNote"
      ></asc-label>
    </template>
    <template v-if="!isDrill">
      <asc-label
        size="md"
        class="asc-report-single-value--text"
        :value="getText"
      ></asc-label>
      <asc-label
        size="md"
        class="asc-report-single-value--value"
        :value="getValue"
      ></asc-label>
      <asc-label
        size="md"
        class="asc-report-single-value--note"
        :value="getNote"
      ></asc-label>
    </template>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscReportSingleValue',

  components: {
    AscLabel,
  },

  props: {
    report: {
      type: Object,
      required: true,
    },
  },

  computed: {
    getText() {
      return (this.report && this.report.text) || ''
    },
    getValue() {
      return (this.report && this.report.value) || ''
    },
    getNote() {
      return (this.report && this.report.note) || ''
    },
    isDrill() {
      return this.report.parameterId !== null
    },
  },

  methods: {
    handleDrillClick(event) {
      if (this.onReportMenuClick) {
        this.onReportMenuClick(event, this.report)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-report-single-value--value-drill {
  text-decoration: underline;
  margin-left: 5px;
  display: inline-block;

  &:hover {
    font-weight: 500;
    cursor: pointer;
  }
}

.asc-report-single-value--text {
  float: left;
}

.asc-report-single-value--value {
  margin-left: 5px;
  display: inline-block;
}

.asc-report-single-value--note {
  margin-left: 5px;
  display: inline-block;
}
</style>
